import { render, staticRenderFns } from "./RankingDnaChampion.vue?vue&type=template&id=7b336116&scoped=true"
import script from "./RankingDnaChampion.vue?vue&type=script&lang=js"
export * from "./RankingDnaChampion.vue?vue&type=script&lang=js"
import style0 from "./RankingDnaChampion.vue?vue&type=style&index=0&id=7b336116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b336116",
  null
  
)

export default component.exports